<template>
    <v-container>
        <!-- :picker-date.sync="showPickerDate" -->
        <!-- <v-date-picker
             v-model="pickerDate"
             full-width
             ></v-date-picker> -->

        <v-card>
            <v-card-title>
                Registro de Salidas y Llegadas
            </v-card-title>
        </v-card>
        <v-data-table
            :headers="headers"
            :items="checkOutItems"
            item-key="serial"
            group-by="Canal"
            :show-group-by="false"
            :items-per-page="50" 
            :footer-props="{
                'items-per-page-options' : [50, 100, -1]
            }"
            dense
            class="elevation-5"
        >
            <!-- Computed properties -------------------------------------------------------------------- -->
            <template v-slot:item.checkoutDate="{ item }">
                {{ formatCheckoutDate( item.checkoutUnixtime ) }}
            </template>
            <template v-slot:item.checkinDate="{ item }">
                {{ formatCheckoutDate( item.checkinUnixtime ) }}
            </template>

            <!-- Column: notes  -->
            <template v-slot:item.notes="{ item }">
                <!-- 
                     <div
                     v-if="item.checkoutUnixtime && item.checkinUnixtime"
                     >
                     {{ item.notes }}
                     </div>
                -->
                <v-edit-dialog
                    :return-value.sync="item.notes"
                    large
                    persistent
                    @save="updateCheckoutItem( item )"
                    v-if="item.checkoutUnixtime"
                >
                    <div v-if="item.notes">{{ item.notes }}</div>
                    <v-btn
                        small
                        :color="! item.notes && item.checkoutType === checkoutType.extra.value ? 'red' : ''"
                        v-if="! item.notes"
                    >
                        {{ checkoutType.addNote.label }}
                    </v-btn>
                    <template v-slot:input>
                        <div class="mt-4 title" >
                            Notas
                        </div>
                        <v-text-field
                            v-model="item.notes"
                            autofocus
                        >
                        </v-text-field>
                    </template>
                </v-edit-dialog>
            </template>

            <!-- Actions -------------------------------------------------------------------------------- -->
            <template v-slot:item.checkoutActions="{ item }">
                <v-btn
                    small
                    :disabled="item.checkoutUnixtime != null"
                    color="green"
                    @click="checkout( item, checkoutType.delivery.value )"
                >
                    {{ checkoutType.delivery.label }}
                </v-btn>
                <v-btn
                    small
                    :disabled="item.checkoutUnixtime != null"
                    color="light-green"
                    @click="checkout( item, checkoutType.extra.value )"
                >
                    {{ checkoutType.extra.label }}
                </v-btn>
                <v-btn
                    small
                    :disabled="item.checkoutUnixtime != null"
                    color="yellow"
                    @click="checkout( item, checkoutType.repairs.value )"
                >
                    {{ checkoutType.repairs.label }}
                </v-btn>
                <v-btn
                    small
                    :disabled="item.checkoutUnixtime != null"
                    color="orange"
                    @click="noCheckout( item, checkoutType.resting.value )"
                >
                    {{ checkoutType.resting.label }}
                </v-btn>
                <v-btn
                    small
                    :disabled="item.checkoutUnixtime == null || item.checkinUnixtime != null"
                    color="red"
                    @click="checkin( item )"
                >
                    {{ checkoutType.checkin.label }}
                </v-btn>
                <v-btn
                    small
                    @click="remove( item )"
                    :disabled="!! item.checkinUnixtime"
                >
                    <v-icon>mdi-undo-variant</v-icon>
                </v-btn>
                <!-- 
                     <v-btn
                     small
                     @click="debug( item )"
                     >
                     <v-icon>mdi-dump-truck</v-icon>
                     </v-btn>
                -->
            </template>
            <!-- ---------------------------------------------------------------------------------------- -->

        </v-data-table>
    </v-container>
</template>

<script>
import { API, Hub } from 'aws-amplify';

import {
    createSensorCheckoutControl,
    updateSensorCheckoutControl,
    deleteSensorCheckoutControl,
    createSensorCheckoutRecord,
    updateSensorCheckoutRecord,
} from '@/graphql/mutations';

import {
    listSensorCheckoutControls,
    listSensorCheckoutRecords,
    listSensorNames,
} from '@/graphql/queries';

import { compareAccounts } from '@/view-accounts-tool';
import {
    compareSensorsByName,
    pingAccount,
    dayjs,
    dayjsFormatFullDate,
    dayjsFormatTime,
    peek,
    property,
    deviceNumberOfChannels,
    deviceSensorName,
} from '@/tools';

import { mapGetters } from 'vuex';

// const DATE_FORMAT = 'YYYY-MM-DD h:mm a';

peek( 'nolint' );

// function localDate( unixtime, utcOffsetMinutes ) {
//     return dayjs.unix( unixtime ).utcOffset( utcOffsetMinutes ).format( 'YYYY-MM-DD' );
// }


/**
 * @param checkoutDate : dayjs
 * @param checkinDate : dayjs
 *
 * @returns [ { checkout : dayjs, checkin : dayjs }, ]
 */
function computeCheckoutPeriods( checkoutDate, checkinDate ) {
    const datePairs = [];
    let checkout = checkoutDate;
    while ( checkout.isBefore( checkinDate ) ) {
        if ( checkout.isSame( checkinDate, 'day' ) ) {
            datePairs.push( {
                checkout : checkout,
                checkin : checkinDate,
            } );
            break;
        }
        let checkin = checkout.hour( 23 ).minute( 59 ).second( 59 );
        datePairs.push( {
            checkout : checkout,
            checkin : checkin,
        } );
        checkout = checkin.add( 1, 'second' );
    }

    return datePairs;
}


export default {
    name: 'StatusView',

    async created() {
        this.globalState = this.$root.$data.globalState;
        Hub.listen( 'monitor', this.hubListenCallback );
    },

    mounted() {
        this.showAccounts();
    },

    data: () => ({

        globalState : {},

        checkoutType : {
            delivery : { label : 'Salida',  value : 'En Ruta' },
            repairs  : { label : 'Taller',  value : 'Taller' },
            extra    : { label : 'Extra',   value : 'Extra' },
            resting  : { label : 'Inmóvil', value : 'Inmóvil' },
            checkin  : { label : 'Llegada' }, // not really a checkout type
            addNote  : { label : 'Añadir Nota' }, // not really a checout type
        },

        headers : [
            {
                text : 'Sensor',
                value : 'SensorName',
            },
            {
                text : 'Salida',
                value : 'checkoutDate',
            },
            {
                text : 'Llegada',
                value : 'checkinDate',
            },
            {
                text : 'Tipo de Salida',
                value : 'checkoutType',
            },
            {
                text : 'Notas',
                value : 'notes',
            },
            {
                text : 'Salidas',
                value : 'checkoutActions',
            },
        ],
        checkOutItems : [],

        accountDevicesCache : {
            loginId : '',
            devices : [],
        },

        sensorNameMap : {},
    }),

    computed : {
        ...mapGetters( {
            userAccounts : 'getUserTndAccounts',
        } ),
    },

    watch: {
    },

    methods : {

        hubListenCallback( data ) {
            if ( ! ['ev:setAccount'].includes( data.payload.event ) )
                return;

            this.showAccounts();
        },


        ////////////////////////////////////////////////////////////////////////////////////////////////////
        // Computed table columns

        formatCheckoutDate( unixtime ) {
            if ( ! unixtime )
                return '';

            const now = dayjs(),
                  checkout = dayjs.unix( unixtime );

            return checkout.isSame( now, 'day' ) ? dayjsFormatTime( checkout ) : dayjsFormatFullDate( checkout );
        },

        ////////////////////////////////////////////////////////////////////////////////////////////////////

        updateCheckoutItem( checkoutItem ) {
            if ( checkoutItem.checkinUnixtime ) {
                this.backendUpdateSensorCheckoutControl( checkoutItem )
                    .then( this.updateSensorCheckoutRecord );
            }
            else {
                this.backendUpdateSensorCheckoutControl( checkoutItem );
            }
        },

        noCheckout( checkoutItem, checkoutType ) {
            checkoutItem.checkoutType = checkoutType;

            const startOfDay = dayjs().startOf( 'day' ),
                  endOfDay = dayjs().endOf( 'day' );

            checkoutItem.ddbCheckoutDate = startOfDay.format();
            checkoutItem.checkoutUnixtime = startOfDay.unix();

            checkoutItem.ddbCheckinDate = endOfDay.format();
            checkoutItem.checkinUnixtime = endOfDay.unix();

            this.backendUpdateSensorCheckoutControl( checkoutItem )
                .then( this.updateSensorCheckoutRecord );
        },

        checkout( checkoutItem, checkoutType ) {
            console.log( `Salida de ${checkoutItem.serial}` );

            let now = dayjs();
            // now = now.subtract( 1, 'day' );

            checkoutItem.ddbCheckoutDate = now.format();
            checkoutItem.checkoutUnixtime = now.unix();
            checkoutItem.checkoutType = checkoutType;

            this.backendUpdateSensorCheckoutControl( checkoutItem );
        },

        checkin( checkoutItem ) {
            console.log( `Llegada de ${checkoutItem.serial}` );
            checkoutItem.ddbCheckinDate = dayjs().format();
            checkoutItem.checkinUnixtime = dayjs().unix();

            this.backendUpdateSensorCheckoutControl( checkoutItem )
                .then( this.updateSensorCheckoutRecord );
        },

        updateSensorCheckoutRecord( checkoutControl ) {
            if ( ! checkoutControl.checkinUnixtime ) {
                console.log( 'No checkin time, not updating the record' );
                return;
            }

            const localDate = ( unixtime ) =>
                dayjs.unix( unixtime ).utcOffset( checkoutControl.utcOffsetMinutes );

            const checkoutDate = localDate( checkoutControl.checkoutUnixtime ),
                  checkinDate = localDate( checkoutControl.checkinUnixtime );

            // peek( 'datePairs' )( computeCheckoutPeriods( checkoutDate, checkinDate ) );
            const checkoutRecords = computeCheckoutPeriods( checkoutDate, checkinDate )
                .map( ( { checkout, checkin } ) => 
                    Object.assign( Object.assign( {}, checkoutControl ), {
                        localDate        : checkout.format( 'YYYY-MM-DD' ),
                        checkoutUnixtime : checkout.unix(),
                        checkinUnixtime  : checkin.unix(),
                        ddbCheckoutDate  : checkout.format(),
                        ddbCheckinDate   : checkin.format(),
                    } ) );

            // peek( 'checkoutRecords' )( checkoutRecords );

            checkoutRecords.map( this.backendUpdateSensorCheckoutRecord );
        },

        debug( checkoutItem ) {
            peek( 'checkoutItem' )( checkoutItem );
            const params = {
                query : listSensorCheckoutRecords,
                // filter doesn't work, we may have to add @searchable to the schema
                // filter : {
                //     serial : { eq : checkoutItem.serial },
                // },
                variables : {
                    limit : 1000,
                },
            };
            API.graphql( params ).then( result => {
                const records = result.data.listSensorCheckoutRecords.items.filter( record =>
                    record.serial === checkoutItem.serial );

                console.log( `Got ${records.length} sensor checkout records` );
                peek( 'records')( records );
            } );
        },

        showAccounts() {
            const previouslyCompleted = ( checkoutControl ) => {
                const now = dayjs(),
                      checkinUnixtime = checkoutControl.checkinUnixtime;

                if ( ! checkinUnixtime )
                    return false;

                return now.isAfter( dayjs.unix( checkinUnixtime ), 'day' );
            };

            const makeAccountItems = ( account, devices, checkoutControlMap ) => {
                const singleChannelDevices = devices.filter( device => deviceNumberOfChannels( device ) < 2 );

                const makeGuiCheckoutControl = ( device ) => {
                    const canal = account.location + ' ' + account.description,
                          sensorName = deviceSensorName( this.sensorNameMap, device );

                    let checkoutControl = checkoutControlMap[ device.serial ];

                    if ( checkoutControl == null || previouslyCompleted( checkoutControl ) ) {
                        checkoutControl = {
                            // GUI only fields, start with uppercase
                            SensorName : sensorName.ch1,
                            Canal : canal,

                            // 
                            serial : device.serial,
                            name : sensorName.ch1,
                            tndAccountLoginId : account.loginId,
                            checkoutUnixtime : null,
                            checkinUnixtime : null,
                            checkoutType : '',
                            utcOffsetMinutes : parseFloat( device.time_diff ),
                            ddbDescription : canal + ' ' + sensorName.ch1,
                            ddbCheckoutDate : '',
                            ddbCheckinDate : '', 
                        };
                    }
                    else {
                        checkoutControl.SensorName = sensorName.ch1;
                        checkoutControl.Canal = canal;
                    }

                    return checkoutControl;
                };

                return singleChannelDevices.sort( compareSensorsByName ).map( makeGuiCheckoutControl  );
            };

            const getDevicePromises = this.userAccounts.map( account =>
                this.getAccountDevices( account ).then( devices => ( { account, devices } ) ) );

            Promise.all( getDevicePromises )
                   // .then( peek( 'accountDevices' ) )
                   .then( accountDevices =>
                       this.getSensorNameMap( accountDevices.flatMap( accountDevice => accountDevice.devices.map( property( 'serial' ) ) ) )
                           .then( sensorNameMap => {
                               this.sensorNameMap = sensorNameMap;
                               peek( 'sensorNameMap')( sensorNameMap );
                               return accountDevices;
                           } )
                   )
                   .then( accountDevices =>
                       this.getSensorCheckoutControls().then( checkoutControlMap => ({
                           accountDevices,
                           checkoutControlMap
                       }) )
                   )
                   // .then( peek( 'after getSensorCheckoutControls') )
                   .then( ( { accountDevices, checkoutControlMap } ) => {
                       return accountDevices.flatMap( accountDevices => makeAccountItems( accountDevices.account, accountDevices.devices, checkoutControlMap ) );
                   } )
                   // .then( peek( 'checkoutItems' ) )
                   .then( checkoutItems => this.setCheckoutItems( checkoutItems ) );

            compareAccounts; // FIXME: use it or remove it
        },

        setCheckoutItems( checkOutItems ) {
            this.checkOutItems = checkOutItems;
        },

        getAccountDevices( account ) {
            return pingAccount( this.globalState.accountDevicesCache, account );
        },

        ////////////////////////////////////////////////////////////////////////////////
        // Back end

        remove( checkoutItem ) {
            // console.log( { remove : checkoutItem } )

            API.graphql( {
                query : deleteSensorCheckoutControl,
                variables : { input : { serial : checkoutItem.serial } },
            } ).catch( error => {
                console.log( 'Error deleting checkout control', error );
            } ).then( () => this.showAccounts() );
        },

        getSensorNameMap( serials ) {
            // peek( 'getSensorNameMap' )( { serials } );
            const params = {
                query : listSensorNames,
                variables : {
                    limit : 2000,
                },
            };

            const toMap = ( map, sensorName ) => {
                map[ sensorName.serial ] = sensorName;

                return map;
            };

            return API.graphql( params )
                      .then( result => {
                          const items = result.data.listSensorNames.items;
                          // peek( 'sensorNameMap' )( { serials, items } );
                          // peek( 'filter')( items.filter( item => serials.includes( item.serial ) ).reduce( toMap, {} ) );
                          return items.filter( item => serials.includes( item.serial ) )
                                      .reduce( toMap, {} );
                      } )
                      .catch( error => {
                          console.log( 'Error calling listSensorNames(): ', error );
                          return {};
                      } );
        },

        backendUpdateSensorCheckoutControl( guiCheckoutControl ) {
            const { Canal, SensorName, ...checkoutControl } = guiCheckoutControl;

            Canal; SensorName; // lint

            const params = {
                query : updateSensorCheckoutControl,
                variables : { input : checkoutControl },
            };

            return API.graphql( params )
                      .then( result => result.data.updateSensorCheckoutControl )
                      .catch( error => {
                          console.log( 'Could not update checkout control, assuming we need to create a new one', error );

                          return this.backendCreateSensorCheckoutControl( checkoutControl );
                      } );
        },

        backendCreateSensorCheckoutControl( checkoutControl ) {
            const params = {
                query : createSensorCheckoutControl,
                variables : { input : checkoutControl },
            };

            return API.graphql( params )
                      .then( result => result.data.createSensorCheckoutControl )
                      .catch( error => console.log( 'Error creating checkout control', error ) );
        },

        /**
         * Get a map of checkoutControl objects.
         * returns: Promise of { serial : checkoutControl } map
         */
        getSensorCheckoutControls() {
            const params = {
                query : listSensorCheckoutControls,
                variables : {
                    limit : 1000,
                },
            };

            const toMap = ( map, checkoutControl ) => {
                map[ checkoutControl.serial ] = checkoutControl;
                return map;
            };

            return API.graphql( params )
                      .then( result => result.data.listSensorCheckoutControls.items )
            // .then( peek( 'getSensorCheckoutControls' ) )
                      .then( checkoutControls => checkoutControls.reduce( toMap, {} ) )
                      .catch( error => {
                          console.log( 'Error calling listSensorCheckoutControls', error );
                      } );
        },

        backendUpdateSensorCheckoutRecord( checkoutRecord ) {
            const params = {
                query : updateSensorCheckoutRecord,
                variables : { input : checkoutRecord },
            };

            // peek( 'Updating a SensorCheckoutRecord' )( params );
            return API.graphql( params )
                      .then( result => result.data.updateSensorCheckoutRecord,
                             error => {
                                 console.log( 'Could not update checkout record, assuming we need to create a new one', error );

                                 return this.backendCreateSensorCheckoutRecord( checkoutRecord );
                             } );
        },

        backendCreateSensorCheckoutRecord( checkoutRecord ) {
            const params = {
                query : createSensorCheckoutRecord,
                variables : { input : checkoutRecord },
            };

            // peek( 'Creating a SensorCheckoutRecord' )( params );
            return API.graphql( params )
                      .then( result => result.data.createSensorCheckoutRecord )
                      .catch( error => console.log( 'Error creating checkout record', error ) );
        },
    },
}
</script>

<style>

tr.v-row-group__header .text-start {
    font-weight: bold;
}

</style>
